<template>
  <div>
    <el-form :model="data" ref="form" label-position="top" :rules="rules">
      <el-form-item label="执行顺序" prop="rc_order">
        <el-input-number v-model.number="data.rc_order"></el-input-number>
      </el-form-item>
      <el-form-item label="系统组件" prop="cm_uuid">
        <el-select filterable v-model="data.cm_uuid" placeholder="请选择">
          <el-option
            v-for="item in comSysList"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <component
      :is="config.activeComponentName"
      v-if="config.activeComponentName"
      v-model="config.data"
      :uuid="data.cm_uuid"
      ref="componentRef"
      :init="!data.rccom_uuid"
    ></component>
  </div>
</template>
<script>
import RcApi from './Rc';
import CommonApi from '@/api/Common';
import Component from './component';

// let defaultData = {
//     rccom_uuid: "",
//     cm_uuid: "",
//     cm_conf: "{}",
//     rc_order: 1,
//     rc_uuid: "",
//     value: ""
// };
export default {
  props: {
    orderIncrement: Number,
    value: {},
  },
  components: { ...Component.editor },
  data() {
    return {
      data: {},
      rules: {
        rc_order: [
          {
            required: true,
            type: 'number',
            min: 1,
            max: 500,
            message: '请输入大于0小于500的数值！',
          },
        ],
        cm_uuid: [{ required: true, message: '这是必填字段' }],
      },
      comSysList: [],

      config: {
        activeComponentName: null,
        data: {},
        componentMatch: Component.match,
      },
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    'data.cm_uuid': 'handleChangeComponent',
  },
  methods: {
    handleChangeComponent() {
      if (this.data.cm_uuid) {
        let idx = this.comSysList.findIndex(
          (item) => item.id === this.data.cm_uuid
        );
        if (idx > -1) {
          this.config.activeComponentName = Component.match(
            this.comSysList[idx].defn
          );
          return;
        }
      }
      this.config.activeComponentName = null;
    },
    async handleSaveRcCom() {
      try {
        let v1 = this.$refs.form.validate();
        let v2 = this.$refs.componentRef.validate();
        await Promise.all([v1, v2]);
        // 请求数据处理
        let reqData = {
          deviceName: this.config.data.deviceName,
          encryption: this.config.data.encryption,
          isHsm:     this.config.data.isHsm,
          senderid: this.config.data.senderid,
          receiverid: this.config.data.receiverid,
          icCard:     this.config.data.icCard,
          copCode:     this.config.data.copCode,
          rootCertDir:     this.config.data.rootCertDir,
        };
        if (this.config.data.deviceName === 'USBKey') {
          reqData.ukeyPassword = this.config.data.ukeyPassword;
        } else if(this.config.data.isHsm === 'UKEY'){
          reqData.ukeyPassword = this.config.data.ukeyPassword;
        } else {
          reqData.signKeyIndex = this.config.data.signKeyIndex;
          reqData.userConfig = this.config.data.userConfig;
          reqData.userCertDir = this.config.data.userCertDir;
          reqData.hsmType = this.config.data.hsmType;
        }
        this.data.cm_conf = JSON.stringify(reqData);
        await this.confirm();
        this.$emit('loading', true);
        if (this.data.rccom_uuid) {
          await RcApi.updateRcCom(this.data);
        } else {
          await RcApi.saveRcCom(this.data);
        }
        this.$emit('refresh');
      } finally {
        this.$emit('loading', false);
      }
    },
    init() {
      let ign = ['ClientInComponent', 'ClientOutComponent'];
      CommonApi.initList().then((data) => {
        this.comSysList = data.comSysList.filter((v) =>
          ign.findIndex((i) => i === v.defn)
        );
        this.handleChangeComponent();
      });

      this.data = {
        rc_uuid: this.value.rc_uuid,
        rccom_uuid: this.value.rccom_uuid,
        cm_uuid: this.value.cm_uuid,
        cm_conf: this.value.cm_conf || '{}',
        rc_order: this.value.rc_order || this.orderIncrement,
      };
      this.config.data = JSON.parse(this.data.cm_conf);
    },
  },
};
</script>
